"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConfirmLoadingButton;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LoadingButton = _interopRequireDefault(require("./LoadingButton"));
var _ConfirmationDialog = _interopRequireDefault(require("./ConfirmationDialog"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ConfirmLoadingButton(_ref) {
  let {
    title,
    confirmationMessage = undefined,
    onAction,
    disabled = false,
    loading = false,
    children,
    ...rest
  } = _ref;
  const [showConfirmation, setShowConfirmation] = (0, _react.useState)(false);
  function onConfirm(isConfirmed) {
    setShowConfirmation(false);
    if (isConfirmed) {
      onAction();
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LoadingButton.default, _extends({
    onClick: () => setShowConfirmation(true),
    title: title,
    disabled: disabled,
    loading: loading
  }, rest), children), showConfirmation && /*#__PURE__*/_react.default.createElement(_ConfirmationDialog.default, {
    title: title,
    message: confirmationMessage,
    onConfirm: onConfirm
  }));
}
ConfirmLoadingButton.defaultProps = {
  disabled: false,
  loading: false
};
ConfirmLoadingButton.propTypes = {
  title: _propTypes.default.string.isRequired,
  confirmationMessage: _propTypes.default.string,
  onAction: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  rest: _propTypes.default.array,
  children: _propTypes.default.node.isRequired
};